module.exports = __webpack_public_path__ + "img/mxr-octavio-fuzz.99a10908.jpg";